import React from 'react';
import BlockClock from '../components/models/blockclock/BlockClock';
import NetworkCongestionPanel from '../components/NetworkCongestionPanel';

const BTN = {
  background: '#383838', color: '#aaa', border: '1px solid #444',
  borderRadius: '3px', padding: '2px 8px', fontSize: '9px',
  cursor: 'pointer', letterSpacing: '0.5px', marginRight: '6px',
  fontFamily: 'inherit', lineHeight: 'normal'
};

export default function Blocks() {
  return (
    <div className="page-models">
      <div className="models-border">
        <div className="models-border-content">

          <div style={{ display: 'flex', alignItems: 'center', padding: '4px 2px', flexShrink: 0 }}>
            <button style={BTN} onClick={() => window.location.href = '/dashboard'}>
              ← DASHBOARD
            </button>
            <span style={{ color: '#444', fontSize: '9px', letterSpacing: '2px' }}>BLOCKS</span>
          </div>

          <div className="models-border-2">
            <div className="models-border-content-2">
              <div className="models-content">
                <BlockClock />
                <NetworkCongestionPanel />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
